<template>
    <main class="container-fluid" style="max-width: 500px">
        <div class="row m-3" v-if="erro">
            <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
                <span v-html="erro"></span>
            </div>
        </div>

        

        <div class="mt-5">
            <div class="align-items-center d-none" style="display: flex; justify-content: space-between;" >
                <div></div>
                <div>
                    <button class="btn w-100 " type="button" @click="irParaAgendamentos">
                        Ver agendamentos
                    </button>
                </div>
            </div>
            <label for="floatingSelect">Selecione a especialidade:</label>
            <div class=" mt-1 py-2" style="border: 1px solid ; border-radius: 5px; padding: 5px;">
                <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        style="font-weight: bold; border: none !important; width: 100%;" 
                        :style="{ 'color': 'var(--cor-principal)' }"
                        v-model="selectedOption" @change="selecionarEspecialidade()">
                    <option v-for="option in listaEspecialidade" :key="option.id" :value="option.id" :disabled="option.disabled" style="height: 200px; font-size: 20px;">
                        {{ option.nome }}
                    </option>
                </select>
            </div>
        </div>

        <div class="mt-4">
            <label for="floatingSelect">Escolha o mês de sua preferência:</label>
            <div class="px-3 py-2">
                <div class="row">
                    <div id="atual" class="col selectable" :class="{ 'selected': selectedDiv === 'atual' }"
                        @click="selectMes('atual')"
                        :style="{ border: '1px solid ' + (selectedDiv === 'atual' ? 'var(--cor-principal)' : 'black') }"
                        style="border: 1px solid black; border-radius: 10px 0 0 10px;">
                        <div style="text-align: center;">
                            <p class="mt-3" :style="{ 'color': selectedDiv === 'atual' ? 'var(--cor-principal)' : '' }"
                                style="color: #666666; font-weight: bold;">{{ nomeMesAtual }}</p>
                        </div>
                    </div>
                    <div id="seguinte" class="col selectable" :class="{ 'selected': selectedDiv === 'seguinte' }"
                        @click="selectMes('seguinte')"
                        :style="{ border: '1px solid ' + (selectedDiv === 'seguinte' ? 'var(--cor-principal)' : 'black') }"
                        style="border: 1px solid black; border-radius: 0 10px 10px 0;">
                        <div style="text-align: center;">
                            <p class="mt-3"
                                :style="{ 'color': selectedDiv === 'seguinte' ? 'var(--cor-principal)' : '' }"
                                style="color: #666666; font-weight: bold;">{{ nomeMesSeguinte }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3" v-if="!diaIsSelecionado">
            <label for="floatingSelect">Escolha o seu dia de sua preferência:</label>
            <div v-for="(data, index) in diasFormatados" :key="`${data.dia}-${index}`">
                <div class="py-2">
                    <div class="px-3">
                        <div class="row">
                            <div id="consultas" class="col-8 selectable"
                                :class="{ 'selected': selectedDiv === 'consultas' }"
                                style="border: 1px solid black; border-radius: 7px 0 0 7px;">
                                <div>
                                    <p class="mt-3" style="color: #666666; font-weight: bold;">{{ data.dia }} {{data.nomeMes }} - {{ data.diaSemana }}</p>
                                </div>
                            </div>
                            <div id="historico" class="col-4 selectable"
                                :class="{ 'selected': selectedDiv === 'historico' }"
                                @click="avancarAgendamento(data)"
                                :style="{ border: '1px solid var(--cor-principal)' }"
                                style="border: 1px solid --cor-principal; border-radius: 0 7px 7px 0; cursor: pointer;">
                                <div style="text-align: center;">
                                    <p class="mt-3" :style="{ 'color': 'var(--cor-principal)' }"
                                        style=" font-weight: bold;">
                                        Avançar</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="diaIsSelecionado">
            <div class="mt-3">
                <div class="py-2">
                    <div class="px-3">
                        <div class="row">
                            <div id="consultas" class="col-12 selectable"
                                :style="{ border: '1px solid var(--cor-principal)' }"
                                style="border: 1px solid black; border-radius: 5px 5px 5px 5px;">
                                <div>
                                    <p class="mt-3" :style="{ 'color': 'var(--cor-principal)' }">{{ diaSelecionado.dia }} {{diaSelecionado.nomeMes }} - {{ diaSelecionado.diaSemana }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="diaIsSelecionado" class="mt-3">
                <label for="floatingSelect">Escolha o horário de sua preferência:</label>
                <div class="py-2" v-for="(horario, index) in horariosDisponiveis" :key="`${horario.horario}-${index}`">
                    <div class="px-3">
                        <div class="row">
                            <div id="consultas" class="col-8 selectable"
                                :class="{ 'selected': selectedDiv === 'consultas' }"
                                style="border: 1px solid black; border-radius: 7px 0 0 7px;">
                                <div>
                                    <p class="mt-3" style="color: #666666; font-weight: bold;">{{ formatHorario(horario) }}</p>
                                </div>
                            </div>
                            <div id="historico" class="col-4 selectable"
                                :class="{ 'selected': selectedDiv === 'historico' }" @click="agendar(horario)"
                                :style="{ border: '1px solid var(--cor-principal)' }"
                                style="border: 1px solid --cor-principal; border-radius: 0 7px 7px 0; cursor: pointer;">
                                <div style="text-align: center;">
                                    <p class="mt-3" :style="{ 'color': 'var(--cor-principal)' }"
                                        style=" font-weight: bold;">
                                        Agendar</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Loading v-if="loading"></Loading>
    </main>
</template>

<script>
import { APITeleMedicinaService } from "@/service/tele-medicina/APITeleMedicinaService";
const apiTeleMedicinaService = new APITeleMedicinaService();
import Loading from "@/components/Loading.vue";

import { mapGetters } from 'vuex';

export default {
    name: "AgendarConsulta",
    components: {
        Loading,
    },
    data() {
        return {
            loading: false,
            listaEspecialidade: null,
            erro: "",
            selectedDiv: "consultas",
            diaIsSelecionado: false,
            listaDias: null,
            dataCheckNameMes: "",
            nomeMesAtual: '',
            nomeMesSeguinte: '',
            diasFormatados: null,
            selectedOption: null,
            mesSelecionado: null,
            listaHorarios: null,
            horariosDisponiveis: [],
        };
    },
    computed: {
        ...mapGetters(['getReagendartemp']),
        reagendartemp() {
            return this.getReagendartemp;
        }
    },
    created() {
        if (this.$store.state.reagendartemp) {
            this.especialidadeSelecionada.value = this.$store.state.reagendartemp.idEspecialidade;
        }
        this.obterEspecialidades();
        this.selectedDiv = "atual";
    },
    mounted() { },
    methods: {
        obterEspecialidades() {
            this.loading = true;
            apiTeleMedicinaService.obterEspecialidades().then(response => {
                this.listaEspecialidade = response;
                for (let especialidade of this.listaEspecialidade) {
                if (especialidade.id === 5 || especialidade.nome === "Clínico Geral") {
                    this.selectedOption = especialidade.id;
                } else {
                    this.selectedOption = this.listaEspecialidade[0].id;
                }
                }
                this.obterDias();
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.data && error.response.data.detail) {
                    const erroDetail = error.response.data.detail;
                    const erroSemPrefixo = erroDetail.replace('Bad Request - ', '');
                    this.erro = erroSemPrefixo;
                } else {
                    this.erro = 'Erro consultar especialidades agendamento: Detalhe do erro não encontrado.';
                }
                window.scrollTo(0, 0);
            });
        },
        obterDias() {
            this.loading = true;
            const dataAtual = new Date();
            const mes = dataAtual.getMonth() + 1;
            const ano = dataAtual.getFullYear();

            const mesSelecionado = `${ano}-${mes.toString().padStart(2, '0')}`;

            apiTeleMedicinaService.obterDias(this.selectedOption ? this.selectedOption : this.listaEspecialidade[0].id, `${this.mesSelecionado ? this.mesSelecionado : mesSelecionado}-01`).then(response => {
                this.listaDias = response;
                this.dataCheckNameMes = `${mesSelecionado}-01`;
                this.getMonthName();
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.data && error.response.data.detail) {
                    const erroDetail = error.response.data.detail;
                    const erroSemPrefixo = erroDetail.replace('Bad Request - ', '');
                    this.erro = erroSemPrefixo;
                    if (erroSemPrefixo === 'Bad Request') {
                        this.erro = 'Erro ao consultar disponibilidade, detalhe do erro não encontrado.';
                    }
                } else {
                    this.erro = 'Erro ao consultar disponibilidade, detalhe do erro não encontrado.';
                }
                window.scrollTo(0, 0);
            });
        },
        getMonthName() {
            if (this.dataCheckNameMes && !isNaN(Date.parse(this.dataCheckNameMes))) {
                const dateObj = new Date(this.dataCheckNameMes);
                const monthIndex = dateObj.getMonth();
                const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

                this.nomeMesAtual = monthNames[monthIndex + 1];
                this.nomeMesSeguinte = monthNames[monthIndex + 2];
            } else {
                this.nomeMesAtual = 'Data inválida';
            }
            this.diasFormatados = this.datasFormatadas(this.listaDias.datasDisponiveis);
            this.loading = false;
        },
        datasFormatadas(datasDisponiveis) {
            return datasDisponiveis.map(data => {
                const dataObj = new Date(data.data + 'T00:00:00Z');
                let dia = dataObj.getUTCDate();
                if (dia < 10) {
                    dia = "0" + dia;
                }
                const mes = dataObj.getUTCMonth() + 1;
                const nomeMes = this.getNomeMes(dataObj.getUTCMonth());
                const diaSemana = this.getDiaSemana(dataObj.getUTCDay());
                const dataDisponivel = data.data;

                this.mesSelecionado = mes;

                return {
                    dia,
                    mes,
                    nomeMes,
                    diaSemana,
                    dataDisponivel
                };
            });
        },
        getNomeMes(mes) {
            const nomesMeses = [
                "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
            ];
            return nomesMeses[mes].toLowerCase();
        },
        getDiaSemana(diaSemana) {
            const diasSemana = [
                "Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira",
                "Quinta-feira", "Sexta-feira", "Sábado"
            ];
            return diasSemana[diaSemana];
        },
        avancarAgendamento(data) {
            this.loading = true;
            this.diaIsSelecionado = true;
            this.diaSelecionado = data;
            apiTeleMedicinaService.obterHorarios(this.selectedOption ? this.selectedOption : this.listaEspecialidade[0].id, data.dataDisponivel).then(response => {
                this.listaHorarios = response;
                this.horariosDisponiveis = [...this.listaHorarios.horariosDisponiveis];
                const compararHorarios = (a, b) => {
                    return new Date(a.horario).getTime() - new Date(b.horario).getTime();
                };
                this.horariosDisponiveis.sort(compararHorarios);
                this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    if (error.response && error.response.data && error.response.data.detail) {
                        const erroDetail = error.response.data.detail;
                        const erroSemPrefixo = erroDetail.replace('Bad Request - ', '');
                        this.erro = erroSemPrefixo;
                    } else {
                        this.erro = 'Erro consultar horários: Detalhe do erro não encontrado.';
                    }
                    window.scrollTo(0, 0);
            });
            window.scrollTo(0, 0);
        },
        obterAgendamentos() {
            this.loading = true;
            apiTeleMedicinaService.obterAgendamentos().then(response => {
                this.listaAgendamentos = response;
                this.verificarAgendamentosExpirados();
                this.loading = false;
            }).catch(error => {
                error;
                this.erro = "Erro ao carregar os agendamentos. <br> Por favor, tente novamente mais tarde.";
                this.loading = false;
            });
        },
        verificarAgendamentosExpirados() {
            const dataAtual = new Date();
            const margemDeTempo = 30;
            dataAtual.setMinutes(dataAtual.getMinutes() - margemDeTempo);
            this.listaAgendamentos.forEach(agendamento => {
                const dataAgendamento = new Date(agendamento.dataHoraAgendamento);
                if (dataAgendamento < dataAtual) {
                    if (dataAgendamento.getDate() === dataAtual.getDate()) {
                        if (dataAgendamento.getHours() < dataAtual.getHours() || (dataAgendamento.getHours() === dataAtual.getHours() && dataAgendamento.getMinutes() <= dataAtual.getMinutes())) {
                            agendamento.status = 'EXPIRADO';
                        }
                    } else {
                        agendamento.status = 'EXPIRADO';
                    }
                }
            });
        },
        agendarConsulta() {
            this.$router.push(`/servico/tele-medicina/agendar`);
            window.scrollTo(0, 0);
        },
        agendar(horarioSelecionado) {
            this.loading = true;
            if (horarioSelecionado) {
                const objetoAgendamento = {
                horaDisponivel: horarioSelecionado.horario,
                idEspecialidade: this.selectedOption ? this.selectedOption : this.listaEspecialidade[0].id,
                idCalendario: horarioSelecionado.idCalendario,
            };
            apiTeleMedicinaService.agendarConsulta(objetoAgendamento)
                .then(response => {
                    this.agendamento = response;
                    this.loading = false;   
                    if(response.idAgendamento){
                        this.$router.push(`/servico/tele-medicina/agendamento-finalizado`);         
                        window.scrollTo(0, 0);
                    }
                })
                .catch(error => {
                    this.erro = error.response.data.title;
                    this.loading = false;
                    window.scrollTo(0, 0);
                });
            }
        },
        selecionarEspecialidade() {
            this.selectedDiv = "atual";
            this.mesSelecionado = null;
            this.diaIsSelecionado = false;
            this.diaSelecionado = null;
            this.obterDias()
        },
        selectMes(mes) {
            this.diaIsSelecionado = false;
            this.diaSelecionado = null;
            this.selectedDiv = mes;

            if (mes === 'atual') {
                const dataAtual = new Date();
                const mes = dataAtual.getMonth() + 1;
                const ano = dataAtual.getFullYear();
                const mesSelecionado = `${ano}-${mes.toString().padStart(2, '0')}`;
                this.mesSelecionado = mesSelecionado;
            } else {
                const dataAtual = new Date();
                const mes = dataAtual.getMonth() + 2;
                const ano = dataAtual.getFullYear();
                const mesSelecionado = `${ano}-${mes.toString().padStart(2, '0')}`;
                this.mesSelecionado = mesSelecionado;
            }

            this.obterDias();
        },
        formatHorario(horario) {
            return new Date(horario.horario).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit"
            });
        },
      irParaAgendamentos(){
            this.$router.push(`/servico/tele-medicina/agendamento`);         
            window.scrollTo(0, 0);
        },
    },
    watch: {
        'especialidadeSelecionada.value': function (novoValor, valorAntigo) {
            if (novoValor !== valorAntigo) {
                this.dataSelecionada = null;
                this.listaDias = null;
            }
        }
    },
};
</script>
<style scoped lang="scss">
button {
    background: var(--cor-principal);
    color: var(--cor-texto);
}

.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.a-divider.a-divider-break {
    text-align: center;
    position: relative;
    top: 2px;
    padding-top: 1px;
    margin-bottom: 14px;
    line-height: 0;

    &:after {
        content: "";
        width: 100%;
        background-color: transparent;
        display: block;
        height: 1px;
        border-top: 1px solid #e7e7e7;
        position: absolute;
        top: 50%;
        margin-top: -1px;
        z-index: 1;
    }

    h5 {
        line-height: 1;
        font-size: 12px;
        color: #767676;
        font-weight: 400;
        z-index: 2;
        position: relative;
        display: inline-block;
        background-color: #fff;
        padding: 0 8px 0 7px;
    }

    .is-invalid {
        border-color: #dc3545;
        padding-right: calc(1.5em + .75rem);
        background-image: url('data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8.046 1.354a.5.5 0 0 0-.892 0L1.137 13.396a.5.5 0 0 0 .446.738h12.834a.5.5 0 0 0 .446-.738L8.046 1.354zm.847 11.793a1 1 0 1 0-1.69 0l-6.25 11a1 1 0 0 0 1.69 1.072l6.25-11z"/></svg>');
        background-repeat: no-repeat;
        background-position: right calc(.375em + .1875rem) center;
        background-size: calc(.75em + .375rem) calc(.75em + .375rem);
    }

    .invalid-feedback {
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545;
    }

    .botoes {
        margin-top: 10px;
    }

    .botoes button {
        margin-right: 10px;
    }

    .custom-heading {
        font-weight: bold;
        color: #500c0c;
        /* Acinzentado */
    }

    .custom-button:hover {
        background-color: #f0f0f0;
        /* Cor de fundo quando hover */
        border-color: #999999;
        /* Cor da borda quando hover */
        color: #000000;
        /* Cor do texto quando hover */
        cursor: pointer;
        /* Altera o cursor quando hover */
    }

    .bordered {
        border: 1px solid black;
        /* Adicione aqui o estilo da borda desejada */
        padding: 10px;
        /* Ajuste conforme necessário */
    }


    .selected p {
        background-color: var(--cor-principal);
    }

}
</style>